import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Switch } from "@/components/ui/switch";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem("cookieConsent");
    if (!hasConsented) {
      setOpen(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem("cookieConsent", "all");
    setOpen(false);
  };

  const handleAcceptSelected = () => {
    // In a real app, you would save the selected preferences
    localStorage.setItem("cookieConsent", "selected");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Cookie Preferences</DialogTitle>
          <DialogDescription>
            We use cookies to enhance your browsing experience, serve
            personalized ads or content, and analyze our traffic.
          </DialogDescription>
        </DialogHeader>

        <Tabs defaultValue="essential">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="essential">Essential</TabsTrigger>
            <TabsTrigger value="functional">Functional</TabsTrigger>
            <TabsTrigger value="analytics">Analytics</TabsTrigger>
          </TabsList>

          <TabsContent value="essential" className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <h4 className="font-medium">Essential Cookies</h4>
                <p className="text-sm text-muted-foreground">
                  These cookies are necessary for the website to function and
                  cannot be switched off.
                </p>
              </div>
              <Switch checked disabled />
            </div>
          </TabsContent>

          <TabsContent value="functional" className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <h4 className="font-medium">Functional Cookies</h4>
                <p className="text-sm text-muted-foreground">
                  These cookies enable personalized features and functionality.
                </p>
              </div>
              <Switch id="functional" defaultChecked />
            </div>
          </TabsContent>

          <TabsContent value="analytics" className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <h4 className="font-medium">Analytics Cookies</h4>
                <p className="text-sm text-muted-foreground">
                  These cookies help us improve our website by collecting
                  information about how you use it.
                </p>
              </div>
              <Switch id="analytics" defaultChecked />
            </div>
          </TabsContent>
        </Tabs>

        <DialogFooter className="flex flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={handleAcceptSelected}>
            Accept Selected
          </Button>
          <Button onClick={handleAcceptAll}>Accept All</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
